export default mask;

/** @ngInject */
function mask(MaskService) {
  return function (input, mask) {
    if (input && mask) {
      var maskService = MaskService.create();
      maskService.generateRegex({mask: mask});
      return maskService.getViewValue(input).withDivisors();
    }
  };
}



/** WEBPACK FOOTER **
 ** ./common/filters/mask.filter.ts
 **/